module.exports = function() {
    let LocalStorageLib = {
        isEnabled: false,
        varValues: {}
    };

    LocalStorageLib.init = function() {
        LocalStorageLib.isEnabled = LocalStorageLib.testIsEnabled();
    };

    //http://stackoverflow.com/a/16427747/761793
    LocalStorageLib.testIsEnabled = function() {
        let test = 'test';
        try {
            localStorage.setItem(test, test);
            localStorage.getItem(test);
            localStorage.removeItem(test);
            return true;
        } catch (e) {
            console.log(e);
            return false;
        }
    };

    LocalStorageLib.setLocalVar = function(varName, setting) {
        if (setting !== null && typeof setting === 'object') {
            setting = JSON.stringify(setting);
        }

        if (LocalStorageLib.isEnabled === true) {
            localStorage.setItem(varName, setting);
            return true;
        } else {
            LocalStorageLib.varValues[varName] = setting;
            return false;
        }
    };

    LocalStorageLib.getLocalVar = function(varName) {
        if (LocalStorageLib.isEnabled === true) {
            return localStorage.getItem(varName);
        } else {
            return LocalStorageLib.varValues[varName];
        }
    };

    LocalStorageLib.removeLocalVar = function(varName) {
        if (LocalStorageLib.isEnabled === true) {
            return localStorage.removeItem(varName);
        } else {
            if (typeof LocalStorageLib.varValues[varName] !== 'undefined') {
                delete LocalStorageLib.varValues[varName];
            }
        }
    };

    //Return a stored JSON string as an object instead of the string
    LocalStorageLib.getJSON = function(varName) {
        let jsonVar = {};
        let localStorageVar = null;
        if (LocalStorageLib.isEnabled === true) {
            localStorageVar = localStorage.getItem(varName);
        } else {
            localStorageVar = LocalStorageLib.varValues[varName];
        }
        if (localStorageVar) {
            jsonVar = JSON.parse(localStorageVar);
        }
        return jsonVar;
    };

    return LocalStorageLib;
};
